import Axios from 'axios';

const ALL_DEVICES = '/iot/devices'

export default {
    getAllDevices() {
        return Axios.get(ALL_DEVICES)
    },
    createDevice(label, psk, mac_addr) {
        return Axios.post(ALL_DEVICES, {label: label, psk: psk, mac_addr: mac_addr})
    },
    deleteDevice(id) {
        return Axios.post(ALL_DEVICES+ '/delete', {device: id})
    },
    enforcedPSK() {
        return Axios.get('/iot/enforced_psk')
    }
}
